import React, { useEffect, useState } from "react";
import _PropTypes from "prop-types";
import LcFetch from "lib/shared/fetch";
import helpers from "helpers/base";
import PayAttemptPoller from "components/payments/PayAttemptPoller";

export default function PaypalUpgradeForm(props) {
  const {
    defaultErrorMessage,
    planCode,
    planId,
    upgradePrice,
    paypalEnvironment
  } = props;
  const { PaypalButton } = props;
  const [paypalActions, setPaypalActions] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  useEffect(() => {
    if (paypalActions.enable && upgradePrice.price) {
      paypalActions.enable();
    }
  }, [paypalActions, upgradePrice.price]);
  const paypalHandlers = {
    onAuthorize: async (data) => {
      setProcessing(true);
      const body = {
        paypal_token: helpers.extractPaypalExpressCheckoutToken(data),
        plan_id: planId,
        proration_date: upgradePrice.prorationDate
      };
      const fetchParams = {
        body: JSON.stringify({ ...body }),
        method: "POST"
      };
      try {
        const response = await LcFetch("/subscription/upgrade", fetchParams);
        const json = await response.json();
        if (response.ok) {
          const poller = new PayAttemptPoller();
          poller.poll(
            json.pay_attempt,
            (finalDestination) => {
              window.location.href = finalDestination;
            },
            () => setErrorMessage(defaultErrorMessage)
          );
        } else {
          setErrorMessage(json.errorMessage);
        }
      } catch (_error) {
        setErrorMessage(defaultErrorMessage);
      } finally {
        setProcessing(false);
      }
    },
    onCancel: () => {
      setDisabled(false);
      setProcessing(false);
    },
    onClick: () => {},
    onError: (error) => {
      setErrorMessage(error.message);
      setDisabled(false);
      setProcessing(false);
    },
    payment: async (resolve, reject) => {
      setDisabled(true);
      const url = "/paypal/billing_agreements";
      const fetchParams = {
        body: JSON.stringify({
          proration_date: upgradePrice.prorationDate,
          subscription: planCode
        }),
        method: "POST"
      };
      const response = await LcFetch(url, fetchParams);
      const data = await response.json();
      if (response.ok) {
        resolve(data.token);
      } else {
        reject(data.errorMessage);
      }
    },
    validate: (actions) => {
      setPaypalActions(actions);
    }
  };

  return (
    <div data-pay-method="paypal">
      <p>
        Clicking on the button below will take you to PayPal to complete your
        transaction.
      </p>
      <PaypalButton
        environment={paypalEnvironment}
        processing={processing}
        disabled={disabled}
        errorMessage={errorMessage}
        showSeparator={false}
        {...paypalHandlers}
      />
    </div>
  );
}
